import { createSlice } from "@reduxjs/toolkit";

const ForgotPassSlice = createSlice({
  name: "forgotPassword",
  initialState: {
    currentData: null,
    isFetching: false,
    error: false,
    errorMessage: null,
    isChecking: false,
    isSubmitting: false,
    resetOk: false,
    checkError: false,
    checkReason: null,
    errorStatus: null,
  },
  reducers: {
    ForgotPassStart: (state) => {
      state.isFetching = true;
      state.error = false;
      state.errorMessage = null;
      state.errorStatus = null;
    },
    ForgotPassSuccess: (state, action) => {
      state.isFetching = false;
      state.currentData = action.payload;
      state.error = false;
      state.errorMessage = null;
      state.errorStatus = null;
    },
    ForgotPassFailure: (state, action) => {
      state.isFetching = false;
      state.error = true;
      state.errorMessage = action.payload?.message || "Request failed";
      state.errorStatus = action.payload?.status ?? null;
    },
    logoutForgotPass: (state) => {
      state.currentData = null;
      state.isFetching = false;
      state.error = false;
      state.errorMessage = null;
      state.isChecking = false;
      state.isSubmitting = false;
      state.resetOk = false;
      state.checkError = false;
      state.errorStatus = null;
    },

    ResetConfirmStart: (state) => {
      state.isSubmitting = true;
      state.error = false;
      state.errorMessage = null;
    },
    ResetConfirmSuccess: (state) => {
      state.isSubmitting = false;
      state.resetOk = true;
    },
    ResetConfirmFailure: (state, action) => {
      state.isSubmitting = false;
      state.error = true;
      state.errorMessage = action.payload?.message || "Request failed";
    },
    checkStart: (state) => {
      state.checkError = false;
      state.checkReason = null;
    },
    checkSuccess: (state) => {
      state.checkError = false;
      state.checkReason = null;
    },
    checkFailure: (state, action) => {
      state.checkError = true;
      state.checkReason = action.payload?.reason || "invalid";
    },
  },
});

export const {
  ForgotPassStart,
  ForgotPassSuccess,
  ForgotPassFailure,
  logoutForgotPass,
  ResetConfirmStart,
  ResetConfirmSuccess,
  ResetConfirmFailure,
  checkFailure,
  checkStart,
  checkSuccess
} = ForgotPassSlice.actions;

export default ForgotPassSlice.reducer;
